import { lazy } from 'react';

const WebsiteAd = lazy(() => import('./website-ad'));
const LeadAd = lazy(() => import('./lead-ad'));

export { WebsiteAd, LeadAd };
